import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

const GAP = 12; // distance from cursor
const PAD = 8; // min distance from viewport edges

// remember the last pointer position so the tooltip can place itself on first render
let lastPointer = { x: 0, y: 0 };
if (typeof window !== "undefined") {
  window.addEventListener(
    "pointermove",
    (e) => (lastPointer = { x: e.clientX, y: e.clientY }),
    { passive: true },
  );
}

const LineChartTooltip = ({ point }) => {
  const boxRef = useRef(null);
  const [pointer, setPointer] = useState(lastPointer);
  const [pos, setPos] = useState({ left: -9999, top: -9999 });

  // follow the pointer while the tooltip is visible
  useEffect(() => {
    const onMove = (e) => setPointer({ x: e.clientX, y: e.clientY });
    window.addEventListener("pointermove", onMove, { passive: true });
    return () => window.removeEventListener("pointermove", onMove);
  }, []);

  // place it: prefer right/below the cursor, flip to left/above if it would overflow,
  // then clamp so both extremes stay fully visible
  useLayoutEffect(() => {
    const el = boxRef.current;
    if (!el) return;
    const { width, height } = el.getBoundingClientRect();
    const vw = window.innerWidth;
    const vh = window.innerHeight;

    let left = pointer.x + GAP;
    if (left + width > vw - PAD) left = pointer.x - GAP - width;
    left = Math.max(PAD, Math.min(left, vw - width - PAD));

    let top = pointer.y + GAP;
    if (top + height > vh - PAD) top = pointer.y - GAP - height;
    top = Math.max(PAD, Math.min(top, vh - height - PAD));

    setPos({ left, top });
  }, [pointer, point.id]);

  return (
    <>
      {/* Nivo still renders this wrapper inside the chart; keep it empty */}
      <span />
      {createPortal(
        <div
          ref={boxRef}
          style={{
            position: "fixed",
            left: pos.left,
            top: pos.top,
            zIndex: 99999,
            pointerEvents: "none",
            display: "flex",
            alignItems: "center",
            background: "white",
            padding: "5px 8px",
            border: "1px solid #ccc",
            borderRadius: 3,
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            whiteSpace: "nowrap",
          }}
        >
          <div
            style={{
              width: 10,
              height: 10,
              background: point.serieColor ?? point.color,
              marginRight: 5,
            }}
          />
          <strong>
            {`${point.data.x}: ${point.data.y}`}
            {point.data.label ? ` ${point.data.label}` : ""}
          </strong>
        </div>,
        document.body,
      )}
    </>
  );
};

export default LineChartTooltip;